import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const HeightActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      d="M0.817493 16.822C0.16997 15.9308 0.367541 14.6834 1.25878 14.0358L17.3961 2.3114C18.2873 1.66388 19.5347 1.86145 20.1823 2.75269L23.1134 6.78702C23.7609 7.67826 23.5633 8.92567 22.6721 9.57319L6.53478 21.2976C5.64354 21.9452 4.39613 21.7476 3.7486 20.8563L0.817493 16.822Z"
      fill="url(#paint0_linear-height)"
    />
    <path
      d="M9.12195 8.35547L10.8446 10.7721"
      stroke="white"
      strokeWidth="1.99468"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9601 4.32446L15.1097 5.86345"
      stroke="white"
      strokeWidth="1.99468"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.98669 11.3058L5.13634 12.8448"
      stroke="white"
      strokeWidth="1.99468"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear-height"
        x1="62.6487"
        y1="-17.3381"
        x2="33.8271"
        y2="-39.7924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F98009" />
        <stop offset="0.999446" stopColor="#FED576" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
